import { render } from "./Member.vue?vue&type=template&id=1a1f758f"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"
script.render = render

export default script